import { useEffect, useState } from "react";
import "./ReviewList.css";

const baseUrl = import.meta.env.VITE_API_URL;

type Review = {
  sno: number;
  name: string;
  mobile: string;
  ref: string;
  rating: number;
  comments: string;
};

type StarRatingProps = {
  rating: number;
};

const StarRating: React.FC<StarRatingProps> = ({ rating }) => {
  return (
    <>
      {[1, 2, 3, 4, 5].map((i) => (
        <i
          key={i}
          className={`fa-star ${i <= rating ? "fa-solid" : "fa-regular"} star`}
        ></i>
      ))}
    </>
  );
};

const ReviewList = () => {
  const [reviews, setReviews] = useState<Review[]>([]);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const res = await fetch(`${baseUrl}/api/reviewapi/GetAll`);
      if (!res.ok) throw new Error("Failed to fetch reviews");
      const data = await res.json();

      const mappedReviews: Review[] = data.map((item: any, index: number) => ({
        sno: index + 1,
        name: item.customer,
        mobile: item.mobile,
        ref: item.reference,
        rating: item.rating,
        comments: item.comments || "-",
      }));

      setReviews(mappedReviews);
    } catch (err) {
      console.error(err);
      alert("Failed to load reviews.");
    } finally {
    }
  };

  const filtered = reviews.filter(
    (r) =>
      (r.name ?? "").toLowerCase().includes(filter.toLowerCase()) ||
      (r.ref ?? "").toLowerCase().includes(filter.toLowerCase()) ||
      (r.mobile ?? "").includes(filter)
  );

  return (
    <div className="ReviewListMain">
      <div className="container review-container">
        <div className="review-card-1">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
            <h2>Review Summary</h2>
            <input
              type="text"
              className="form-control filter-box mt-3 mt-md-0"
              placeholder="🔍 Search by name, ref, or mobile..."
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            />
          </div>

          <div className="table-responsive">
            <table className="table align-middle text-center">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Customer Name</th>
                  <th>Mobile No</th>
                  <th>Reference</th>
                  <th>Rating</th>
                  <th>Comments</th>
                </tr>
              </thead>
              <tbody>
                {filtered.length > 0 ? (
                  filtered.map((r) => (
                    <tr key={r.sno}>
                      <td>{r.sno}</td>
                      <td className="fw-semibold">{r.name}</td>
                      <td>{r.mobile}</td>
                      <td>
                        <span className="badge bg-light text-dark">{r.ref}</span>
                      </td>
                      <td>
                        <div className="rating-box">
                          <StarRating rating={r.rating} />
                        </div>
                      </td>
                      <td className="text-start comment-text">{r.comments}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-muted py-4">
                      No matching results found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewList;
